import React, { useEffect, useRef } from "react";
import Footer from "../../../components/layout/Footer/Footer";
import { FrmttdPrc } from "../../../components/FormattedPrice/FormattedPrice";
import {
  Btn,
  Container,
  H1,
  H2,
  ImgContainer,
  Text1,
  Span,
  Block,
  ImgBlock,
  TitleBlock,
  TextBlock,
  Box,
  Circle1,
  CircleText1,
  BoxText,
  BoxTitleB,
  BoxTitleN,
  CircleContainer,
  Box1,
  ImgCont,
  TextCont,
  TextBlock1,
  TitleBlock1,
  TextWrap,
  SmallText,
  Container1,
  Btn2,
  Box2,
  Box21,
  Span1,
  SmallText1,
  H1W,
  H2W,
  BtnW,
  FAQCont2,
  FAQuestion,
  Spinner,
  FAQCircle,
  FAQ1,
  InnerText,
} from "./styles";
import { goTo, useNavigation } from "../../../types/Navigates";
import {
  Btn5,
  BtnText,
  Circle,
  Circleq,
  CircleText,
  Item,
  ItemContainer1,
  ItemContainer2,
  ItemContainer3,
  ItemText,
  Meeting,
  Price,
  ScrollContainer2,
  Smth,
  X,
} from "../../Main/styles";
import { FAQText } from "../../../components/FAQ/styles";
import { FAQ } from "../../../components/FAQ/FAQ";
import { Tag } from "../../../components/Ratings/styles";
import { Ratings } from "../../../components/Ratings/Ratings";
import { BookingPopup } from "../../../components/BookingPopUp/ThePopup/BookingPopup";
import urlText from "../../../types/urlText";
import {
  Block1Container,
  CircleContainer2,
  CircleContainer3,
} from "../Services2/styles";
import { BoxTitleN2, BoxText2 } from "../Services1/styles";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getCard } from "../../../store/slices/cardSlice";
import { getProductCategories } from "../../../store/slices/productCategoriesSlice";

const Services5 = () => {
  const { toServices, toConsult, toMain, toRatings } = useNavigation();
  const scrollcontainerRef = useRef(null);
  const innerTextRef1 = useRef(null);
  const innerTextRef2 = useRef(null);
  const innerTextRef3 = useRef(null);
  const innerTextRef4 = useRef(null);
  const container1Ref = useRef(null);

  useEffect(() => {
    const scrollcontainer = scrollcontainerRef.current;
    const innerText1 = innerTextRef1.current;
    const innerText2 = innerTextRef2.current;
    const innerText3 = innerTextRef3.current;
    const innerText4 = innerTextRef4.current;
  });
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  useEffect(() => {
    dispatch(getCard(8));
    dispatch(getProductCategories());
  }, []);
  const card = useSelector((state: RootState) => state.card.card);
  const filteredProducts = card.filter(
    (item) => item.product_category.id === 4
  );

  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const productCats = productCategories.find((item) => item.id === 4);

  const scroll2 = () => {
    if (container1Ref.current) {
      container1Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        container1Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const scroll = () => {
    if (scrollcontainerRef.current) {
      scrollcontainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const ShowinnerText1 = () => {
    if (innerTextRef1.current) {
      innerTextRef1.current.style.display == "none"
        ? (innerTextRef1.current.style.display = "block")
        : (innerTextRef1.current.style.display = "none");
    }
  };
  const ShowinnerText2 = () => {
    if (innerTextRef2.current) {
      innerTextRef2.current.style.display == "none"
        ? (innerTextRef2.current.style.display = "block")
        : (innerTextRef2.current.style.display = "none");
    }
  };
  const ShowinnerText3 = () => {
    if (innerTextRef3.current) {
      innerTextRef3.current.style.display == "none"
        ? (innerTextRef3.current.style.display = "block")
        : (innerTextRef3.current.style.display = "none");
    }
  };
  const ShowinnerText4 = () => {
    if (innerTextRef4.current) {
      innerTextRef4.current.style.display == "none"
        ? (innerTextRef4.current.style.display = "block")
        : (innerTextRef4.current.style.display = "none");
    }
  };
  const smthRef = useRef(null);
  const smth = smthRef.current;
  const ShowPopUp = () => {
    smthRef.current.style.display = "block";
    window.scrollTo(0, 0);
  };
  const HidePopUp = () => {
    smthRef.current.style.display = "none";
  };
  return (
    <>
      <Smth ref={smthRef}>
        <X onClick={HidePopUp} $img={require("../../Main/X.jpg")}></X>
        <BookingPopup />
      </Smth>
      <ImgContainer $img={require("./bg.png")}>
        {productCats ? <H1>{productCats.title}</H1> : <></>}
        <H2>
          Вместе с Любовью Прохоровой пройдете каждый этап испытательного срока
          без стресса и с максимальным результатом.
        </H2>
        <Btn onClick={goTo}>Бесплатная консультация</Btn>
      </ImgContainer>
      <Container>
        <Text1>
          Кому подходит
          <Span>сопровождение?</Span>
        </Text1>
      </Container>
      <Container>
        <Block>
          <ImgBlock $img={require("./v2.png")} />
          <TitleBlock>Важно показать результат</TitleBlock>
          <TextBlock>Нет времени на погружение, нужен результат</TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v1.png")} />
          <TitleBlock>Не уверены в себе</TitleBlock>
          <TextBlock>
            Синдром самозванца и отсутствие внутреннего профессионала внутри
          </TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v3.png")} />
          <TitleBlock>Стремитесь к быстрому росту</TitleBlock>
          <TextBlock>Создание прочных связей с первого рабочего дня</TextBlock>
        </Block>
      </Container>
      <Text1>Как строится работа?</Text1>
      <Container>
        <Box>
          <CircleContainer3>
            <Circle1 />
            <CircleText1>01</CircleText1>
          </CircleContainer3>
          <BoxTitleN>Поставим</BoxTitleN>
          <BoxTitleB>Цели</BoxTitleB>
          <BoxText>Обсудим запрос до оплаты, поставим цели</BoxText>
        </Box>
        <Box>
          <CircleContainer3>
            <Circle1 />
            <CircleText1>02</CircleText1>
          </CircleContainer3>
          <BoxTitleN>Планируем</BoxTitleN>
          <BoxTitleB>Встречи</BoxTitleB>
          <BoxText>Выберем график и время для встреч</BoxText>
        </Box>
        <Box>
          <CircleContainer3>
            <Circle1 />
            <CircleText1>03</CircleText1>
          </CircleContainer3>
          <BoxTitleN>Будем</BoxTitleN>
          <BoxTitleB>Рядом 24/7</BoxTitleB>
          <BoxText>
            Между встречами эксперт будет отвечать на вопросы и давать
            рекомендации в чате 24/7
          </BoxText>
        </Box>
        <Box1>
          <CircleContainer3>
            <Circle1 />
            <CircleText1>04</CircleText1>
          </CircleContainer3>
          <BoxTitleN>Получаем</BoxTitleN>
          <BoxTitleB>Результат</BoxTitleB>
          <BoxText>
            После каждой встречи вы получите тезисы разговора, полезные
            материалы и домашние задания
          </BoxText>
        </Box1>
      </Container>
      <Text1>
        Что вы получите<Span>в итоге ?</Span>
      </Text1>
      <Container>
        <ImgCont $img={require("./bg2.jpg")} />
        <TextCont>
          <TextWrap>
            <TitleBlock1>Уверенность в себе</TitleBlock1>
            <TextBlock1>
              Прогоним внутреннего самозванца и взрастим профессионала.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Поддержку от новой команды</TitleBlock1>
            <TextBlock1>
              Не просто наладите отношения, а заручитесь поддержкой и уважением
              коллектива.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Достигнутые цели</TitleBlock1>
            <TextBlock1>
              Добьетесь поставленных целей и подтвердите свою компетентность
              перед руководителем.
            </TextBlock1>
          </TextWrap>
        </TextCont>
      </Container>
      <SmallText>ТАРИФЫ</SmallText>
      <Text1>Как мы можем помочь</Text1>
      <Container1 ref={container1Ref}>
        <Block1Container>
          {filteredProducts && productCats ? (
            filteredProducts.map((product) => (
              <Item $img={require("./item.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circleq />
                    <CircleText>{productCats.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
        </Block1Container>
      </Container1>
      <Text1>
        Мы приносим<Span>результат</Span>
      </Text1>
      <Container>
        <Box>
          <BoxTitleN2>1000+</BoxTitleN2>
          <BoxText2>
            Клиентов, которым мы помогли решить карьерные задачи
          </BoxText2>
        </Box>
        <Box2>
          <BoxTitleN2>50+</BoxTitleN2>
          <BoxText2>
            Успешно-пройденных испытательных сроков с нашей командой
          </BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>x2</BoxTitleN2>
          <BoxText2>Средний рост зарплаты наших клиентов</BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>20</BoxTitleN2>
          <BoxText2>Cтран, где мы закрываем карьерные запросы</BoxText2>
        </Box2>
        <Box21>
          <BoxTitleN2>4+</BoxTitleN2>
          <BoxText2>Года работы компании Prohorova Consult</BoxText2>
        </Box21>
      </Container>
      <Text1>Отзывы</Text1>
      <ScrollContainer2 ref={scrollcontainerRef}>
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <ImgContainer $img={require("./bg3.png")}>
        <SmallText1>бесплатная консультация</SmallText1>
        <H1W>Остались вопросы ?</H1W>
        <H2W>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы.
        </H2W>
        <BtnW href={`https://t.me/ProhorovaConsult?text=${urlText}`}>
          Оставить заявку
        </BtnW>
      </ImgContainer>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <FAQ />
        <FAQCont2>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как можно узнать подробней об услуге ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText1} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef1}>
            Оставьте заявку на сайте, менеджер свяжется с вами и назначит
            встречу-знакомство, где подробно разберем ваш кейс и расскажем о
            прогнозах поиска.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Можно оплатить услугу частями ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText2} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef2}>
            Да, вы можете оплатить услугу несколькими частями. Мы готовы
            согласовать с вами удобный формат.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как юридически оформлена работа ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText3} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef3}>
            Мы заключаем договор, где прописаны все условия и критерии
            выполнения услуги.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как можно подготовиться к встрече ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText4} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef4}>
            После бронирования встречи на сайте, с вами свяжется менеджер и
            направит всю информацию для подготовки.
          </InnerText>
        </FAQCont2>
      </Container>
      <Footer />
    </>
  );
};
export default Services5;
